import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {HandleErrorService} from './handle-error.service';
import Swal from 'sweetalert2';
import {ApiService} from '../core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  constructor(private serviceApi: ApiService, private handleError: HandleErrorService) {
  }

  editSlider(body): Observable<any> {
    return this.serviceApi.put(`Master/USlider`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  createSlider(body): Observable<any> {
    return this.serviceApi.post(`Master/Slider`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  deleteSlider(id): Observable<any> {
    return this.serviceApi.delete(`Master/ByIdSlider/${id}`)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  editComment(body): Observable<any> {
    return this.serviceApi.put(`Master/UComment`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  createComment(body): Observable<any> {
    return this.serviceApi.post(`Master/Comment`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  deleteComment(id): Observable<any> {
    return this.serviceApi.delete(`Master/ByIdComments/${id}`)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  editBanner(body): Observable<any> {
    return this.serviceApi.put(`Master/UBannerPromo`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  createBanner(body): Observable<any> {
    return this.serviceApi.post(`Master/BannerPromo`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  deleteBanner(id): Observable<any> {
    return this.serviceApi.delete(`Master/ByIdBannerPromo/${id}`)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  editTitle(body): Observable<any> {
    return this.serviceApi.put(`Master/USection`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  changeStatusSection(body): Observable<any> {
    return this.serviceApi.patch(`Master/StatusSection`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  getSidenavLinks(): Observable<any> {
    return this.serviceApi.get(`Master/Menu`)
      .pipe(catchError(this.handleError.catchHttpError));
  }

  changeSliderStatus(body): Observable<any> {
    return this.serviceApi.patch(`Master/StatusSlider`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  changeCommentStatus(body): Observable<any> {
    return this.serviceApi.patch(`Master/StatusComments`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  changeBannerStatus(body): Observable<any> {
    return this.serviceApi.patch(`Master/StatusBannerPromo`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  getRequirementClaimtags(): any {
    return this.serviceApi.get(`Master/StatusRequerimentReclaim`)
      .pipe(
        catchError(this.handleError.catchHttpError)
      );
  }

  getAllUbigeos(): Observable<any> {
    return this.serviceApi.get(`Master/Ubigeo`)
      .pipe(
        catchError(this.handleError.catchHttpError)
      );
  }

  insertMasterPdf(body): Observable<any> {
    return this.serviceApi.put(`Master/UPdf`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  getList(listId: number, id: number): Observable<any> {
    return this.serviceApi.get<any>(
      `Master/Virtual/${listId}/Id/${id}`
    );
  }
}
